import o from "react";
import { Link as m } from "../../../Link/Link.js";
import { StaticFooter as a } from "../Static/StaticFooter.js";
import { cls as n } from "../../../../helpers/cls.js";
import { Flex as l } from "../../../Flex/Flex.js";
import { oldLinks as c } from "../../utils/links.js";
import { sendClickEvent as i } from "../../utils/sendClickEvent.js";
const t = "footer",
  f = r => o.createElement("footer", {
    id: "footer",
    "data-ds-component": "DS-Footer",
    className: n("olx-default-footer", r.className)
  }, o.createElement(l, {
    className: "olx-default-footer__links-container"
  }, c.map(e => o.createElement(m, {
    key: e.name,
    dsParentName: t,
    href: e.href,
    variant: "grey",
    size: "small",
    onClick: () => i(e.clickEvent, t),
    "data-ds-component": "DS-Footer-Link"
  }, e.name))), o.createElement(a, {
    componentName: t
  }));
export { f as OldFooter };